import { graphql } from '../graphql/generated';

export const DOCTOR_SEARCH_QUERY = graphql(`
  query DoctorSearch {
    doctorsForCurrentUser {
      id
      name
      firstName
      lastName
      zip
      city
      meAddress
      disabled
      assignedLabs {
        lab {
          id
          shortName
        }
        customerId
      }
    }
  }
`);
